import {
  NgModule
} from '@angular/core';
import {
  RouterModule,
  Routes
} from '@angular/router';
import {
  AccountComponent
} from './components/account/account.component';
import {
  DashComponent
} from './components/dashboard/dash.component';
// import {
//   DevicedetailsComponent
// } from './components/devicedetails/devicedetails.component';
import {
  DevicelistComponent
} from './components/devicelist/devicelist.component';
import {
  GatekeeperComponent
} from './components/gatekeeper/gatekeeper.component';
// import {
//   GroupsComponent
// } from './components/groups/groups.component';
import {
  NavComponent
} from './components/nav/nav.component';
import {
  ResetpassComponent
} from './components/resetpass/resetpass.component';
// import {
//   ThingsComponent
// } from './components/things/things.component';
// import {
//   UsersComponent
// } from './components/users/users.component';

const routes: Routes = [

  {
    path: 'dashboard',
    component: DashComponent
  },
  {
    path: 'devicelist',
    component: DevicelistComponent
  },
  {
    path: 'account',
    component: AccountComponent
  },
 
  // {
  //   path: '**',
  //   redirectTo: '/gatekeeper'
  // },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
